export default __webpack_public_path__ + "26c74e4bfe7bd29d540ac22795b32377.svg";